
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LandingFormData } from "../hooks/useLandingForm";

interface CredentialsSectionProps {
  formData: LandingFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CredentialsSection = ({ formData, handleChange }: CredentialsSectionProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="username">Username</Label>
        <Input
          id="username"
          name="username"
          type="text"
          value={formData.username}
          onChange={handleChange}
          placeholder="Username"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Password"
        />
      </div>
    </div>
  );
};

export default CredentialsSection;
